/* eslint-disable @typescript-eslint/naming-convention */
import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { UserAccountQuery } from '../store/userAccount/user-account.query';

@Injectable({
  providedIn: 'root'
})
export class ViewSwitcherService {
  private _router = inject(Router);
  private _userAccountQuery = inject(UserAccountQuery);

  private readonly _appViewLocalStorageKey = 'sustainment-portal-app-view';

  public appViews: PortalAppViewConfig[] = [
    { title: 'buyer', icon: 'ti ti-currency-dollar' },
    { title: 'supplier', icon: 'ti ti-truck-delivery' },
    { title: 'community', icon: 'ti ti-users' }
  ];

  public userRoles = this._userAccountQuery.session?.userRoles;
  public currentAppView = signal<PortalAppView>('buyer');

  public constructor() {
    const prevViewSetting = localStorage.getItem(
      this._appViewLocalStorageKey
    ) as PortalAppView;

    const onlyHasSupplierRole =
      this.userRoles?.includes('Supplier') && this.userRoles.length === 1;

    this.setAppView(
      prevViewSetting
        ? prevViewSetting
        : onlyHasSupplierRole
          ? 'supplier'
          : 'buyer'
    );
  }

  public setAppView(
    view: PortalAppView,
    /**
     * Options to control the behavior of the view switch action
     * @param resetToHome - If true, navigate to the home page after setting the view
     * @param skipLocalStorage - If true, do not save the view to local storage
     * @param routeRedirect - If provided, redirect to this route instead of home
     */
    opts?: {
      resetToHome?: boolean;
      skipLocalStorage?: boolean;
      routeRedirect?: string;
    }
  ): void | Promise<unknown> {
    this.currentAppView.set(view);

    if (!opts?.skipLocalStorage) {
      localStorage.setItem(this._appViewLocalStorageKey, view);
    }

    if (opts?.routeRedirect) {
      return this._router.navigate([opts.routeRedirect]);
    }

    opts?.resetToHome && this._router.navigate(['home']);
  }
}

export type PortalAppView = 'buyer' | 'supplier' | 'community';
export type PortalAppViewConfig = {
  title: PortalAppView;
  icon: string;
};
